<template>
  <div>
    <span class="pa-2 ma-2">Switch user</span>

    <v-autocomplete
      v-model="selected_user"
      :items="users"
      item-text="name"
      item-value="user_id"
      outlined
      dense
      open-on-clear
      label="User name"
      @change="switch_user()"
    ></v-autocomplete>
  </div>
</template>
<script>
export default {
  props: {
    users: Array,
  },
  data() {
    return {
      selected_user: "",
    };
  },
  mounted() {
    this.syncUser();
  },
  watch: {
    $route() {
      this.syncUser();
    },
  },
  methods: {
    switch_user() {
      this.$emit("switch_user", { user_id: this.selected_user });
    },

    syncUser() {
      // sync filters with query params in router
      let query_params = JSON.parse(JSON.stringify(this.$route.query));
      this.selected_user =
        query_params.selected_user || this.$route.params.user_id;
    },
  },
};
</script>
<style></style>
